import React from 'react';
import '../Style/components.css';

export default function FileViewer({ file, open_close_file }) {
  const unsupported = () => {
    alert('Unsupported File Format!: ' + file.data.type);
    open_close_file(false);
  };
  return (
    <div
      style={file.show ? { display: 'flex' } : { display: 'none' }}
      className="file-viewer"
    >
      <div className="file-viewer-body">
        <div className="close" onClick={() => open_close_file(false)}>
          <i className="fi-rr-cross"></i>
        </div>
        <h3 className="head_text">{file.name ? file.name : null}</h3>
        <div className="file-viewer-item">
          {file.data && file.data !== null ? (
            file.data.type === 'image' ? (
              <img className="display_image" src={file.data.url} alt="img" />
            ) : file.data.type === 'video' ? (
              <video src={file.data.url} controls width={500} />
            ) : file.data.type === 'audio' ? (
              <audio controls src={file.data.url} />
            ) : file.data.type === 'text' ? (
              <p>{file.data.url}</p>
            ) : file.data.type === 'pdf' ? (
              <iframe
                width={600}
                title={file.name}
                src={file.data.url}
              ></iframe>
            ) : (
              unsupported()
            )
          ) : null}
        </div>
      </div>
    </div>
  );
}
